import { createReducer } from '@reduxjs/toolkit';
import { Nullable } from 'modules/types/common';
import { oc } from 'ts-optchain';
import * as actions from './actions';
import { DeepLinkAction } from './types';

export interface DeepLinkState {
  action: Nullable<DeepLinkAction>;
  deepLinkUrl: Nullable<string>;
  useInitialDeepLink: Boolean;
}

const initialState: DeepLinkState = {
  action: null,
  deepLinkUrl: null,
  useInitialDeepLink: true
};

const DeepLinkReducer = createReducer(initialState, {
  [actions.GET_DEEPLINK_ACTION]: state => {
    state.action = {
      isFetching: true
    };
  },
  [actions.GET_DEEPLINK_ACTION_FAIL]: state => {
    state.action = {
      isFetching: false
    };
  },
  [actions.GET_DEEPLINK_ACTION_SUCCESS]: (state, action) => {
    state.action = {
      isFetching: false,
      id: oc(action).payload.data.id(''),
      type: oc(action).payload.data.type(''),
      sourceId: oc(action).payload.data.sourceId(''),
      consumerId: oc(action).payload.data.consumerId(''),
      relatedData: oc(action).payload.data.relatedData({})
    };
  },
  [actions.SET_DEEPLINK_URL]: (state, action) => {
    state.deepLinkUrl = action.payload.url;
  },
  [actions.RESET_DEEPLINK]: state => {
    state.action = null;
    state.deepLinkUrl = null;
  },
  [actions.SET_USE_INITIAL_DEEPLINK]: (state, action) => {
    state.useInitialDeepLink = action.payload.updateInitialDeepLink;
  }
});

export default DeepLinkReducer;
